// TODO import from @apollo/client all graphql-tag
import getMonth from 'date-fns/getMonth'
import getYear from 'date-fns/getYear'
import gql from 'graphql-tag'
import {
  CoverLetterUtils_GetSpecInfo_CoverLetterFragment,
  CoverLetterUtils_GetPassedAtText_CoverLetterFragment,
} from 'generated/graphql'
import { filterArrayEmpty } from 'utils/utils'

export const getSpecInfo = (
  coverLetter?: CoverLetterUtils_GetSpecInfo_CoverLetterFragment | null,
) => {
  return filterArrayEmpty([
    coverLetter?.university,
    coverLetter?.major,
    coverLetter?.grades && '학점 ' + coverLetter?.grades,
    coverLetter?.languageScore,
    coverLetter?.career,
    coverLetter?.activity,
    coverLetter?.license,
  ]).join(' / ')
}

gql`
  fragment CoverLetterUtils_getSpecInfo_coverLetter on CoverLetter {
    university
    major
    grades
    languageScore
    career
    activity
    license
  }
`

export const getPassedAtText = (
  coverLetter?: CoverLetterUtils_GetPassedAtText_CoverLetterFragment | null,
): string => {
  const passedAt = coverLetter?.passedAt ?? 0

  return `${getYear(passedAt)} ${
    getMonth(passedAt) >= 1 && getMonth(passedAt) <= 6 ? '상반기' : '하반기'
  }`
}
gql`
  fragment CoverLetterUtils_getPassedAtText_coverLetter on CoverLetter {
    passedAt
  }
`
